import merge from 'lodash/merge.js';

import ActivityLog from '@/store/modules/activitylog/ActivityLog.js';
import Collection from '@/store/quill/Collection.js';
import EdverumTable from '@/store/utilities/EdverumTable.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

const collectionHelpers = EdverumTable.collection('activity-log');

export default merge(Collection('ActivityLogs', ActivityLog), {
    state: {
        sort: {
            subject_type: null,
            created_at: 'desc',
            updated_at: null,
        },
    },

    getters: {
        ...collectionHelpers.getters,

        url(state, getters, rootState, rootGetters) {
            // ActivityLogs uses deprecated menu loading - consider using MenuService pattern
            console.warn(
                'ActivityLogs store uses deprecated menu loading. Consider using MenuService.loadAndSetCourseMenu() instead.'
            );
            return new QueryBuilder('activity-logs')
                .sort(getters.queryBuilderSorting)
                .setPagination(getters.paginate)
                .when(rootGetters['ActivityLogView/hasFilters'], builder =>
                    builder.raw(rootGetters['ActivityLogView/filters'])
                )
                .menu()
                .toUrl();
        },
    },

    actions: {
        fetch: collectionHelpers.actions.fetch(({ context, queryBuilder }) => {
            const { getters, rootGetters } = context;

            queryBuilder.sort(getters.queryBuilderSorting).setPagination(getters.paginate);

            if (rootGetters['ActivityLogView/hasFilters']) {
                queryBuilder.raw(rootGetters['ActivityLogView/filters']);
            }
        }),

        clearSort: collectionHelpers.actions.clearSort,
        paginateAndFetch: collectionHelpers.actions.paginateAndFetch,
    },

    mutations: {
        CLEAR_SORTING: collectionHelpers.mutations.CLEAR_SORTING,
    },
});
